export const EVENT_TYPES = {
  MEETING: 'meeting',
  TASK: 'task',
  REMINDER: 'reminder',
  DEADLINE: 'deadline',
  CALL: 'call',
  OTHER: 'other'
};

export const EVENT_TYPE_LABELS = {
  [EVENT_TYPES.MEETING]: 'Reunión',
  [EVENT_TYPES.TASK]: 'Tarea',
  [EVENT_TYPES.REMINDER]: 'Recordatorio',
  [EVENT_TYPES.DEADLINE]: 'Fecha límite',
  [EVENT_TYPES.CALL]: 'Llamada',
  [EVENT_TYPES.OTHER]: 'Otro'
};

export const EVENT_TYPE_COLORS = {
  [EVENT_TYPES.MEETING]: '#1976d2',
  [EVENT_TYPES.TASK]: '#2e7d32',
  [EVENT_TYPES.REMINDER]: '#ed6c02',
  [EVENT_TYPES.DEADLINE]: '#d32f2f',
  [EVENT_TYPES.CALL]: '#9c27b0',
  [EVENT_TYPES.OTHER]: '#757575'
};

export const createEventItem = () => ({
  title: '',
  description: '',
  eventType: EVENT_TYPES.MEETING,
  startDate: new Date().toISOString(),
  endDate: new Date(Date.now() + 3600000).toISOString(),
  allDay: false,
  color: EVENT_TYPE_COLORS[EVENT_TYPES.MEETING],
  createdBy: null,
  createdByName: '',
  assignedTo: [],  // ✅ Ahora es un array: [] = evento general, [uid1, uid2] = asignado a usuarios específicos
  sharedWith: [],
  isActive: true,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
});